import styled from 'styled-components'
import { ReactComponent as RightArrowHeadIcon } from '../../assets/right-arrow-head.svg'

export const DownArrow = styled(RightArrowHeadIcon)`
  fill: ${props => props.theme.colors.grey11};
  height: 14px;
  transform: rotate(90deg);
`

export const UpArrow = styled(DownArrow)`
  transform: rotate(270deg);
`
